import type { RouteRecordRaw } from "vue-router"

export const ApplicationTypeSelectionRoutes: RouteRecordRaw[] = [
  {
    path: "application-type-selection",
    component: () => import("./ApplicationTypeSelection.vue"),
  },
]
